import { Text } from '@consta/uikit/Text'

import type { TableRow } from '../types'
import css from './SidebarRow.css'

export const SidebarRow = ({ type, value = 'Нет данных' }: TableRow) => {
  return (
    <div className={css.sidebarRow}>
      <Text size="s" className={css.sidebarRowLabel} view="secondary">
        {type}
      </Text>
      <Text size="s" className={css.sidebarRowText} view="primary">
        {value}
      </Text>
    </div>
  )
}
